(function($) {
	formHelper.addRule({
		form: '.form-manage-exports',
		status: {
			SUCCESS: function() {
				this.redirect(this.data.redirectTo);
			},
			ERROR_MESSAGE_ONE: function() {
				if(this.data.systemMessage1) {
					$('#system-message-1').html(this.data.systemMessage1);
				}
			},
			ERROR_MESSAGE_TWO: function() {
				if(this.data.systemMessage2) {
					$('#system-message-2').html(this.data.systemMessage2);
				}
			},
			ERROR_MESSAGE_THREE: function() {
				if(this.data.systemMessage3) {
					$('#system-message-3').html(this.data.systemMessage3);
				}
			},
			ERROR_MESSAGE_FOUR: function() {
				if(this.data.systemMessage4) {
					$('#system-message-4').html(this.data.systemMessage5);
				}
			}
		}
	});
})(jQuery);

jQuery(function initToolsManageExports($) {
	$('.manage-exports-form').each(function(index, el) {

		var $container             		= $(this);
		var $form                  		= $container.find('#form-manage-exports');

		// Date Range
		// ------------------
		var $dateRangeStart = $('#date-range-start').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var dateRangeStartPicker = $dateRangeStart.pickadate('picker');

		var $dateRangeEnd = $('#date-range-end').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var dateRangeEndPicker = $dateRangeEnd.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( dateRangeStartPicker.get('value') ) {
			dateRangeEndPicker.set('min', dateRangeStartPicker.get('select'));
		}
		
		if ( dateRangeEndPicker.get('value') ) {
			dateRangeStartPicker.set('max', dateRangeEndPicker.get('select'));
		}

		// When something is selected, update the "dateRangeStart" and "dateRangeEnd" limits.
		dateRangeStartPicker.on('set', function(event) {
			if ( event.select ) {
				dateRangeEndPicker.set('min', dateRangeStartPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				dateRangeEndPicker.set('min', false);
			}
		});

		dateRangeEndPicker.on('set', function(event) {
			if ( event.select ) {
				dateRangeStartPicker.set('max', dateRangeEndPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				dateRangeStartPicker.set('max', false);
			}
		});	
	});
});
